import React from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import EmailInput from '../../components/Inputs/EmailInput';
import TextInput from '../../components/Inputs/TextInput';
import ReactSelect from '../../components/Inputs/ReactSelect';
import { COUNTRIES } from '../../helpers/selectOptions';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useClinics from '../../store/clinics/clinicsContext';
import { CLINIC_TYPES } from '../../config';

function AddClinic() {
  
  const history = useHistory();

  const {
    createClinic
  } = useClinics();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [newClinic, _setNewClinic] = React.useState({
    type: null,
    name: null,
    phoneNb: null,
    email: null,
    city: null,
    address: null,
    postalCode: null,
    country: null,
  });

  const setNewClinic = (newVal) => _setNewClinic({...newClinic, ...newVal});

  const countryOptions = [];
  if (!countryOptions.length) COUNTRIES.forEach(country => {
    countryOptions.push({
      value: country,
      label: country
    })
  });
  
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  const handleCreate = () => {
    if (newClinic.name === '' || newClinic.name === null) {
      return validateField('name',  "Please enter a clinic name." )
    }
    if (newClinic.type === '' || newClinic.type === null ) {
      return validateField('type',   "Please enter clinic type." )
    }
    if (!validateEmail(newClinic.email)) {
      return validateField('email', "Please enter a valid email." )
    }
    if (newClinic.phoneNb === '' || newClinic.phoneNb === null ) {
      return validateField('phoneNb',   "Please enter number." )
    }
    if (newClinic.country === '' || newClinic.country === null ) {
      return setFormError({
        field: 'country',
        msg:  "Please select country." 
      });
    }
    if (newClinic.city === '' || newClinic.city === null ) {
      return setFormError({
        field: 'city',
        msg:  "Please enter city." 
      });
    }
    if (newClinic.address === '' || newClinic.address === null ) {
      return setFormError({
        field: 'address',
        msg:  "Please enter address." 
      });
    }
    if (newClinic.postalCode === '' || newClinic.postalCode === null ) {
      return setFormError({
        field: 'postalCode',
        msg:  "Please enter postal code." 
      });
    }
    createClinic(newClinic).then(() => {
      history.push('/manage-clinics');
    });
  }

  const validateField = (field, msg) => {
    let element = document.getElementById(field);
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    return setFormError({
      field: field,
      msg:  msg
    });
  }

  const clinicTypeOptions = [];
  if (!clinicTypeOptions.length) Object.entries(CLINIC_TYPES).map(([key, value]) => (
    clinicTypeOptions.push({
      label: value,
      value: value
    })
  ));
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Clinic information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <TextInput id='name' label='Clinic name*' inputClass='col-span-3' value={newClinic.name} onChange={(e) => setNewClinic({name: e.target.value})}/>
          {formError.field === 'name' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <ReactSelect id='type' label='Clinic type*' options={clinicTypeOptions} value={newClinic.type} inputClass='col-span-3' onChange={(e) => setNewClinic({ type: e.value })} /> 
          {formError.field === 'type' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <EmailInput id='email' horizontal label='Email*'  inputClass='col-span-3' data={newClinic.email} onChange={(e) => setNewClinic({email: e.target.value})} />
          {formError.field === 'email' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='phoneNb' inputClass='col-span-3' label='Mobile*' data={newClinic.phoneNb} onChange={(e) => setNewClinic({phoneNb: e.target.value})} />
          {formError.field === 'phoneNb' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className="bg-white rounded shadow py-12 px-10 mt-6">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Clinic location</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>  
          <ReactSelect id='country' label='Country*' options={countryOptions} value={newClinic.country} inputClass='col-span-3' onChange={(e) => setNewClinic({ country: e.value })} /> 
          {formError.field === 'country' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='city' inputClass='col-span-3' label='City*' data={newClinic.city} onChange={(e) => setNewClinic({city: e.target.value})} />
          {formError.field === 'city' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='address' inputClass='col-span-3' label='Address*' data={newClinic.address} onChange={(e) => setNewClinic({address: e.target.value})} />
          {formError.field === 'address' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='postalCode' inputClass='col-span-3' label='Postal code*' data={newClinic.postalCode} onChange={(e) => setNewClinic({postalCode: e.target.value})} />
          {formError.field === 'postalCode' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.push('/manage-clinics')} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddClinic
